import styled from "styled-components"
import { motion } from "framer-motion"

export const StyledErrorCheckbox = styled(motion.div)`
  position: absolute;
  bottom: -50px;
  background-color: var(--white);
  border-radius: 10px;
`
